import React from 'react';
import { TableRow, TableCell, Skeleton } from '@mui/material';

const TableRowsSkeleton = ({ rows = 10, columns = 8 }) => {
  const renderSkeletonCells = () => {
    const skeletonCells = [];
    for (let i = 0; i < columns; i++) {
      skeletonCells.push(
        <TableCell key={`skeleton-cell-${i}`}>
          <Skeleton animation="wave" />
        </TableCell>
      );
    }
    return skeletonCells;
  };

  const renderSkeletonRows = () => {
    const skeletonRows = [];
    for (let i = 0; i < rows; i++) {
      skeletonRows.push(
        <TableRow key={`skeleton-row-${i}`}>
          {renderSkeletonCells()}
        </TableRow>
      );
    }
    return skeletonRows;
  };

  return <>{renderSkeletonRows()}</>;
};

export default TableRowsSkeleton;
